/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Publish_ConfirmInputs */

const cs_workflow_publish_confirm = /** @type {(inputs: Workflow_Publish_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikovat tento workflow? Aktuální graf se stane publikovanou verzí.`)
};

const en_workflow_publish_confirm = /** @type {(inputs: Workflow_Publish_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish this workflow? The current graph will become the published version.`)
};

/**
* | output |
* | --- |
* | "Publish this workflow? The current graph will become the published version." |
*
* @param {Workflow_Publish_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_publish_confirm = /** @type {((inputs?: Workflow_Publish_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Publish_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_publish_confirm(inputs)
	return cs_workflow_publish_confirm(inputs)
});